import React from 'react';

import type { WithMediaClientConfigProps } from '@atlaskit/media-client-react/with-media-client';

import { type ClipboardConfig } from '../../types';
import { type ClipboardProps } from './clipboard';

type ClipboardWithMediaClientConfigProps = WithMediaClientConfigProps<
	// ClipboardBase defines config default value, which modifies final shape of ClipboardBase component.
	// Specifically this changes one of the props - config, it makes it an optional property.
	// We want ClipboardWithMediaClientConfigProps to match this modified props of ClipboardBase here.

	Omit<ClipboardProps, 'config'> & {
		config?: ClipboardConfig;
	}
>;
type ClipboardWithMediaClientConfigComponent =
	React.ComponentType<ClipboardWithMediaClientConfigProps>;

type State = {
	Clipboard?: ClipboardWithMediaClientConfigComponent;
};

export class ClipboardLoader extends React.PureComponent<
	ClipboardWithMediaClientConfigProps,
	State
> {
	static displayName = 'AsyncClipboard';
	static Clipboard?: ClipboardWithMediaClientConfigComponent;

	state: {
		Clipboard: ClipboardWithMediaClientConfigComponent | undefined;
	} = {
		Clipboard: ClipboardLoader.Clipboard,
	};

	componentDidMount(): void {
		if (!this.state.Clipboard) {
			Promise.all([
				import(
					/* webpackChunkName: "@atlaskit-internal_media-client-react_with-media-client" */ '@atlaskit/media-client-react/with-media-client'
				),
				import(/* webpackChunkName: "@atlaskit-internal_media-clipboard" */ './clipboard'),
			]).then(([mediaClient, clipboardModule]) => {
				// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
				ClipboardLoader.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);

				this.setState({
					Clipboard: ClipboardLoader.Clipboard,
				});
			});
		}
	}

	render(): React.JSX.Element | null {
		if (!this.state.Clipboard) {
			return null;
		}

		return <this.state.Clipboard {...this.props} />;
	}
}
